import { NgModule } from '@angular/core';
import { SdvorSearchUiLazyModule } from '@sdvor/search/ui';
import { SearchDataAccessModule } from '@search/data-access';
import { SearchFeatureModule } from '@search/feature';
import { SearchUtilsModule } from '@search/utils';

@NgModule({
  imports: [SearchDataAccessModule, SearchFeatureModule, SearchUtilsModule, SdvorSearchUiLazyModule],
})
export class SdvorSearchShellModule {}
